import React, { useContext, useState, useEffect} from "react";
import ActionsContext from "common/ActionsContext";
import { getBqnIdCmdPart } from "common/api";
import BqnContext from "common/BqnContext";
import ColumnsGrid from "common/layouts/ColumnsGrid";
import SelectInput from "common/SelectInput";
import Request from "common/Request";
import { ReportContextControlsLayout } from "../utils";
import Table from "common/graphs/Table/Table";
import { parseIP, durationToInt } from "common/utils";
import { NumberCell, TimeCell } from "common/graphs/Table/TableRenders";
import { hoursScopeChoices, hoursAsPeriod } from "common/constants";
import View from "common/View";
import Help from "./Help";
import { openSubscriberDetails } from "views/Status/Subscribers/Report/index";

const retrieval = ({ hours, mode, bqnId }) =>
  ifCl.run(`show statistics dos volume hours  ${hours}${getBqnIdCmdPart(mode, bqnId)}`);

const returnTo = "viewDoSVolumeStats";

const getColumns = ({ timePeriod }) => [
    {
      label: "TIME",
      id: "TIME",
      numeric: false,
    },
    {
      label: "IP-ADR",
      id: "IP-ADDRESS",
      numeric: false,
      parse: parseIP,
      cellClassName: "hyperlink-text",
      onClick: (addr) => openSubscriberDetails({ addr }, timePeriod, returnTo),
      parseFilter: (value) => value
    },
    {
      label: "MBYTES",
      id: "MBYTES4",
      numeric: true,
      renderCell: (value) => (
        <NumberCell value={value} hasNA={false} precision={0} />
      ),
    },
    {
      label: "RATE-Mbps",
      id: "RATE-Mbps",
      numeric: true,
      renderCell: (value) => (
        <NumberCell value={value} hasNA={false} precision={0} />
      ),
    },
    {
      label: "DURATION",
      id: "DURATION",
      numeric: true,
      renderCell: (value) =>
        (value === "ongoing") ? "ongoing" :
        <TimeCell value={value} />,
      parse: (value) => (value === "ongoing" ? null : durationToInt(value)),
    },
    {
      label: "TOP-CONTRIBUTOR",
      id: "TOP-CONTRIBUTOR",
      numeric: false,
      parse: parseIP,
      parseFilter: (value) => value
    },
    {
      label: "TOP-MBYTES",
      id: "MBYTES8",
      numeric: true,
      renderCell: (value) => <NumberCell value={value} hasNA={false} />,
    },
  ];

const DoSVolumeStats = () => {
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);
  const [hours, setHours] = useState(24);
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const doLoad = () => {
    const doingRetrieval = retrieval({ hours, bqnId, mode }).catch(
      (error) => error
    );
    setRequest(doingRetrieval);
  };
  useEffect(() => {
    doLoad();
    return actions.recv('do-load', doLoad);
  }, [hours, bqnId]);


  return (
    <View title="DoS volume attacks over time" Help={Help} >
      <ReportContextControlsLayout>
        <ColumnsGrid columns={4} maxWidth="15rem" minWidth="9cm" rowGap="0">
          <SelectInput
            label="Most recent"
            name="hours"
            onChange={(event) => setHours(event.target.value)}
            defaultValue={hours}
            options={hoursScopeChoices}
          />
        </ColumnsGrid>
      </ReportContextControlsLayout>
      <div className="body flex-panel-column">
        {request === null ? null : (
          <Request during={request.then((response) => ({ response }))}>
            {({ response }) => {
              const [header, ...rows] = response.trim().split("\n");
              const headerAttrs = header.trim().split(/\s+/);
              const newRows = rows.map((row) => {
                const rowAttrs = row.trim().split(/\s+/);
                const newEntry = rowAttrs.reduce((acc, attr, index) => {
                  let attrName = headerAttrs[index];
                  if (attrName === "MBYTES"){
                    attrName = `MBYTES${index}`;
                  }
                  acc[attrName] = attr;
                  return acc;
                }, {});
                return newEntry;
              });
              return (
                <div className="body table-responsive">
                  <Table
                    isSelectable={false}
                    isRowSelectable={false}
                    data={newRows}
                    sort={true}
                    columns={getColumns({timePeriod: hoursAsPeriod[hours]})}
                    search={true}
                    csvPrefix="volume-attacks"
                    rowsPerPageNr={50}
                  />
                </div>
              );
            }}
          </Request>
        )}
      </div>
    </View>
  );
};

export default DoSVolumeStats;
